import { render, staticRenderFns } from "./AddressComponent.vue?vue&type=template&id=01f25d34&"
import script from "./AddressComponent.vue?vue&type=script&lang=js&"
export * from "./AddressComponent.vue?vue&type=script&lang=js&"
import style0 from "./AddressComponent.vue?vue&type=style&index=0&id=01f25d34&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports